import { render, staticRenderFns } from "./RegulatorLayout.vue?vue&type=template&id=6d1c54dc&scoped=true"
import script from "./RegulatorLayout.vue?vue&type=script&lang=ts"
export * from "./RegulatorLayout.vue?vue&type=script&lang=ts"
import style0 from "./RegulatorLayout.vue?vue&type=style&index=0&id=6d1c54dc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1c54dc",
  null
  
)

export default component.exports